export default __webpack_public_path__ + "static/media/team-4.fbb9a3c2.png";